import { createDynamicThunk } from ".";

/**
 * LIST Users
 */
export const fetchUsersThunk = createDynamicThunk({
  typePrefix: "users/fetchUsersThunk",
  useHandleSearch: true,
});

/**
 * ADD / EDIT User
 */
export const submitUserThunk = createDynamicThunk({
  typePrefix: "users/submitUserThunk",
  endpoint: "/users",
  method: "POST",
});

/**
 * Fetch Hierarchy Users
 */
export const fetchHierarchyUsersAsDropdownThunk = createDynamicThunk({
  typePrefix: "fetchHierarchyUsersAsDropdownThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

/**
 * Fetch Roles
 */
export const fetchRoleAsDropdownThunk = createDynamicThunk({
  typePrefix: "fetchRoleAsDropdownThunk",
  endpoint: "/roles/fetchWithoutPagination",
  method: "GET",
});

/**
 * Fetch Clients
 */
export const fetchClientAsDopdownThunk = createDynamicThunk({
  typePrefix: "fetchClientAsDopdownThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

/**
 * Fetch Departments
 */
export const fetchDepartmentAsDopdownThunk = createDynamicThunk({
  typePrefix: "fetchDepartmentAsDopdownThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

export const updateRoleThunk = createDynamicThunk({
  typePrefix: "updateRoleThunk",
  endpoint: "/updateRole",
  method: "POST",
});
